export default "__VITE_PUBLIC_ASSET__a68cd488__"